import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { useLocation } from "wouter";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import type { BlogCard } from "./BlogStoryCard";

export function BlogLikeButton({ post }: { post: BlogCard }) {
  const { user, loading } = useAuth();
  const [, navigate] = useLocation();
  const [count, setCount] = useState(post.likeCount);
  const [liked, setLiked] = useState(post.likedByMe);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setCount(post.likeCount);
    setLiked(post.likedByMe);
    setError("");
  }, [post.id, post.likeCount, post.likedByMe]);

  async function changeLike() {
    if (!user) { navigate("/login"); return; }
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      // [content.account-likes](../../../docs/product/public-content.md#content-account-likes): display confirmed state only; retries set a desired state, never toggle blindly.
      const summary = await api.setBlogLike(post.slug, !liked);
      setCount(summary.likeCount);
      setLiked(summary.likedByMe);
    } catch { setError("Could not save your like. Try again."); }
    finally { setBusy(false); }
  }

  return <div className="bp-like-control">
    <button className="bp-social-action" aria-label={`${liked ? "Unlike" : "Like"} ${post.title}`} aria-pressed={liked} disabled={busy || loading} onClick={changeLike}>
      <Heart size={18} fill={liked ? "currentColor" : "none"} aria-hidden="true" />
      <span aria-live="polite">{count ?? 0}</span>
    </button>
    {error && <p className="bp-like-error" role="alert">{error}</p>}
  </div>;
}
